module.exports = __webpack_public_path__ + "img/coupon_bg11.bba7b60f.png";